/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupArtistsResponseArtistsInnerMembersInner } from './LookupArtistsResponseArtistsInnerMembersInner';
import {
    LookupArtistsResponseArtistsInnerMembersInnerFromJSON,
    LookupArtistsResponseArtistsInnerMembersInnerFromJSONTyped,
    LookupArtistsResponseArtistsInnerMembersInnerToJSON,
} from './LookupArtistsResponseArtistsInnerMembersInner';

/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditChangeArtistsArtistLinkInner
 */
export interface BulkEditRequestBulkEditChangeArtistsArtistLinkInner {
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistLinkInner
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistLinkInner
     */
    source: BulkEditRequestBulkEditChangeArtistsArtistLinkInnerSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistLinkInner
     */
    stageName: string;
    /**
     * 
     * @type {Array<LookupArtistsResponseArtistsInnerMembersInner>}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistLinkInner
     */
    members?: Array<LookupArtistsResponseArtistsInnerMembersInner>;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistLinkInner
     */
    featuredStatus?: BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFeaturedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistLinkInner
     */
    op?: BulkEditRequestBulkEditChangeArtistsArtistLinkInnerOpEnum;
}


/**
 * @export
 */
export const BulkEditRequestBulkEditChangeArtistsArtistLinkInnerSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz'
} as const;
export type BulkEditRequestBulkEditChangeArtistsArtistLinkInnerSourceEnum = typeof BulkEditRequestBulkEditChangeArtistsArtistLinkInnerSourceEnum[keyof typeof BulkEditRequestBulkEditChangeArtistsArtistLinkInnerSourceEnum];

/**
 * @export
 */
export const BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFeaturedStatusEnum = {
    Fa: 'fa',
    Ofa: 'ofa'
} as const;
export type BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFeaturedStatusEnum = typeof BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFeaturedStatusEnum[keyof typeof BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFeaturedStatusEnum];

/**
 * @export
 */
export const BulkEditRequestBulkEditChangeArtistsArtistLinkInnerOpEnum = {
    Add: 'add',
    Replace: 'replace'
} as const;
export type BulkEditRequestBulkEditChangeArtistsArtistLinkInnerOpEnum = typeof BulkEditRequestBulkEditChangeArtistsArtistLinkInnerOpEnum[keyof typeof BulkEditRequestBulkEditChangeArtistsArtistLinkInnerOpEnum];


/**
 * Check if a given object implements the BulkEditRequestBulkEditChangeArtistsArtistLinkInner interface.
 */
export function instanceOfBulkEditRequestBulkEditChangeArtistsArtistLinkInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "stageName" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFromJSON(json: any): BulkEditRequestBulkEditChangeArtistsArtistLinkInner {
    return BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditChangeArtistsArtistLinkInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'source': json['source'],
        'stageName': json['stageName'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerFromJSON)),
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
        'op': !exists(json, 'op') ? undefined : json['op'],
    };
}

export function BulkEditRequestBulkEditChangeArtistsArtistLinkInnerToJSON(value?: BulkEditRequestBulkEditChangeArtistsArtistLinkInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.sourceId,
        'source': value.source,
        'stageName': value.stageName,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerToJSON)),
        'featuredStatus': value.featuredStatus,
        'op': value.op,
    };
}

